import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TagType } from '../shared/tag-type.type';
import { TranslateService } from '@ngx-translate/core';
import { EntityType } from '../../rl-common/shared/shared/entity-type.enum';
import { HttpClient } from '@angular/common/http';
import { TagDisplay } from '../tag/tag-display';
import { UtilsService } from '../../rl-common/shared/core/utils.service';
import { EventPoolService } from '../../core/event-pool.service';
import { TagsChangesEvent } from '../../core/classes/tags-changes-event';
import { FlagService } from '../../core/flag.service';
import { Sort } from '../../rl-common/shared/shared/types/sort';
import { AuthService } from '../../ajs-upgraded-providers';
import { Tag } from '../../store/model/tag.model';

@Injectable({
  providedIn: 'root'
})

export class NgTagsService {
  tagsOptions: any = [];

  constructor(private translate: TranslateService, private http: HttpClient, private utilsService: UtilsService, private flagService: FlagService,
    private authService: AuthService, eventPoolService: EventPoolService) {
    this.getTagsOptions().subscribe(tagsOptions => {
      if (tagsOptions.CITATION.PRIVATE) {
        tagsOptions.CITATION.PRIVATE = tagsOptions.COLLECTION.PRIVATE;
      }
      this.tagsOptions = tagsOptions;
    });

    eventPoolService.tagsListener$.subscribe((e: TagsChangesEvent) => {
      if (e.tag.tagTypeFromEntity == 'PRIVATE' && e.type == 'ADD') {
        if (this.tagsOptions[e.tag.entityTypeObj]['PRIVATE'] && this.tagsOptions[e.tag.entityTypeObj]['PRIVATE'].findIndex(tag => tag.code === e.tag.tagCode) == -1) {
          this.tagsOptions[e.tag.entityTypeObj]['PRIVATE'].push({ 'code': e.tag.tagCode, 'order': 0 });
        }
      }
    });
  }

  create = (entityType: EntityType, entityId: string, tag: Tag): Observable<any> => this.http.post<any>(`../rl/tags/${entityType}/${entityId}`, tag);
  delete = (entityType: EntityType, entityId: string, tid: string): Observable<any> => this.http.delete<any>(`../rl/tags/${entityType}/${entityId}/${tid}`);
  get = (entityType: EntityType, entityId: string): Observable<any> => this.http.get<Tag>(`../rl/tags/${entityType}/${entityId}`);
  getTagsOptions = (): Observable<any> => this.http.get<any>(`../rl/tags/tagsTablesOptions`);

  createTagsToDisplay = (tags: any[], hierarchy: string, isStudentView: boolean) : Tag[] => {
    let tagsToDisplay = [];
    if (!tags?.length) {
      return;
    }
    for (let tag of Object.values(tags)) {
      let newTag = new Tag(tag);
      if (this.canViewTag(newTag.tagTypeFromEntity, hierarchy, isStudentView)) {
        this.setRemoveTag(newTag, hierarchy);
        if (!newTag.tagText) {
          newTag.tagText = this.translate.instant(newTag.tagCode);
        }
        tagsToDisplay.push(newTag);
      }
    }

    return tagsToDisplay;
  }

  canViewTag(tagType: string, hierarchy: string, isStudentView: boolean) {
    let isStudent = this.authService.isStudent() || isStudentView;
    if (hierarchy == 'OWNER' || hierarchy == 'COLLABORATOR') return true;
    if (tagType == 'PUBLIC' || tagType == 'PRIVATE' || tagType == 'SUBJECT' || tagType == undefined) return true;
    return (!isStudent && (tagType == 'LIBRARY' || tagType == 'WORKFLOW'));
  }

  setRemoveTag(tag: Tag, hierarchy: string) {
    if (tag.tagTypeFromEntity == 'SYSTEM') {
      return;
    }

    let isLibrarian = this.authService.isLibrarianOrAdmin();
    if (isLibrarian || tag.entityTypeObj == EntityType.COLLECTION || tag.tagTypeFromEntity == 'PRIVATE') {
      tag.canRemove = true;
    }

    else if (tag.tagTypeFromEntity != 'LIBRARY_EXTERNAL' && (hierarchy == 'OWNER' || hierarchy == 'COLLABORATOR')) {
      tag.canRemove = true;
    }
  }

  getTags(entityType: EntityType): TagDisplay[] {
    let tags: TagDisplay[] = [];
    let tagsList = this.tagsOptions[entityType];
    if (!tagsList) {
      return tags;
    }
    
    Object.keys(tagsList).forEach((tagType: TagType) => tagsList[tagType].forEach(t => {
      tags.push(new TagDisplay(this.translate.instant(t.code), t.code, tagType, entityType, t.order));
    }));

    return this.sortTagDisplay(tags, entityType);
  }

  sortTagDisplay(tags: TagDisplay[], entityType: EntityType) {
    // default sort : customerSetting.tag_sorting == 'group'
    // customerSetting.tag_sorting == 'table' (do not sort by tags type goups)
    let sortBy = [];

    if (this.flagService.customerSetting().tag_sorting == 'group' &&
      (entityType == EntityType.CITATION || entityType == EntityType.SECTION)) {
      sortBy.push({ field: 'type', dir: 'desc' });
    }

    sortBy.push({ field: 'order', dir: 'asc' });
    sortBy.push({ field: 'name', dir: 'asc' });
    return this.utilsService.sortComplex(tags, sortBy);
  }

  addTagToOptions(newTag: Tag) {
    if (this.tagsOptions['CITATION']['PRIVATE'] && this.tagsOptions['CITATION']['PRIVATE'].findIndex(tag => tag.code === newTag.tagCode) == -1) {
      this.tagsOptions['CITATION']['PRIVATE'].push({ 'code': newTag.tagCode, 'order': 0 });
    }

    if (this.tagsOptions['COLLECTION']['PRIVATE'] && this.tagsOptions['COLLECTION']['PRIVATE'].findIndex(tag => tag.code === newTag.tagCode) == -1) {
      this.tagsOptions['COLLECTION']['PRIVATE'].push({ 'code': newTag.tagCode, 'order': 0 });
    }
  }
}
